export default {
	title: 'Monthly Diagnostic Report',
	selectAll: 'Select All',
	selectedCount: 'Selected {count} item(s)',
	batchDelete: 'Batch Delete',
	batchDeleteWithCount: 'Batch Delete ({count})',
	sendEmail: 'Send Email',
	sendEmailWithCount: 'Send Email ({count})',
	noData: {
		title: 'No Monthly Diagnostic Reports',
		description: 'No relevant monthly diagnostic report data found'
	},
	reportCard: {
		coverAlt: 'Monthly Diagnostic Report Cover',
		author: 'Author',
		approver: 'Approver',
		updateTime: 'Update Time'
	},
	status: {
		completed: 'Completed',
		editing: 'Editing'
	},
	actions: {
		upload: 'Upload',
		download: 'Download',
		audit: 'Audit',
		audited: 'Audited',
		delete: 'Delete',
		sendEmail: 'Send Email',
		batchDelete: 'Batch Delete'
	},
	emailDialog: {
		title: 'Send Email',
		ccPerson: 'CC Person',
		selectCcPerson: 'Please select CC person',
		cancel: 'Cancel',
		confirm: 'Confirm'
	},
	messages: {
		selectReportWarning: 'Please select diagnostic report',
		selectCcPersonWarning: 'Please select CC person',
		sendSuccess: 'Sent successfully',
		deleteConfirm: 'Are you sure to delete the selected {count} items?',
		deleteSuccess: 'Deleted successfully',
		selectDeleteWarning: 'Please select records to delete',
		operateSuccess: 'Operation successful',
		fileUploadSuccess: 'File uploaded successfully',
		fileUploadError: 'File upload failed',
		fileTypeError: 'Only PDF and Word documents are allowed!',
		fileSizeError: 'File size cannot exceed 10MB!',
		auditSuccess: 'Audit successful',
		auditWarning: 'This report has been completed',
		auditConfirm: 'Are you sure to approve this report?'
	},
	form: {
		fileName: 'Report Name',
		startTime: 'Start Time',
		endTime: 'End Time',
		title: 'Title',
		filePath: 'File Path',
		fileType: 'File Type',
		startDate: 'Start Date',
		endDate: 'End Date',
		attachment: 'Attachment',
		requiredFieldCannotBeEmpty: 'Required field cannot be empty',
		add: 'Add',
		update: 'Update',
		manualUpload: 'Manual Upload',
		systemGenerate: 'System Generate'
	},
	table: {
		title: 'Title',
		fileName: 'Report Name',
		filePath: 'File Path',
		type: 'File Type',
		startDate: 'Start Date',
		endDate: 'End Date',
		updateTime: 'Update Time'
	}
}
